var _circle, _circle2, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 235,
    viewBox: "0 0 212 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87.0006,
    cy: 131.98,
    r: 72.7329,
    fill: "#FBFBFD",
    stroke: "#0E1324"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5882,
    cy: 131.543,
    r: 61.9784,
    transform: "rotate(-1.01698 87.5882 131.543)",
    fill: "#FBFBFD",
    stroke: "#0E1324"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 181.241,
    y: 225.186,
    width: 12.8794,
    height: 68.0197,
    rx: 1.38976,
    transform: "rotate(135 181.241 225.186)",
    fill: "#FBFBFD",
    stroke: "#0E1324"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.7 102.717L116.545 103.079L116.86 103.315L169.403 142.574L109.132 116.7L108.77 116.545L108.534 116.86L69.2753 169.403L95.149 109.132L95.3044 108.77L94.9888 108.534L42.4462 69.2753L102.717 95.149L103.079 95.3044L103.315 94.9888L142.574 42.4462L116.7 102.717Z",
    fill: "#FBFBFD",
    stroke: "#0E1324"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty_search.b8b70e4140fcb0c1b47a8434f52c3427.svg";
export { ForwardRef as ReactComponent };